// ─────────────────────────────────────────────────────────────
// CENTRAL CONTENT CONFIGURATION — edit everything commercial here.
// ─────────────────────────────────────────────────────────────

export const BRAND = {
  codename: 'Codename Metro One',
  location: 'Navade',
  project: 'Aarohi Complex',
  developer: 'Today Shyam Developers',
  rera: 'P52000015331',
  reraUrl: 'https://maharera.maharashtra.gov.in',
  tagline: ['READY TODAY.', 'CONNECTED TO TOMORROW.'],
  logo: '/assets/logo.webp',
  logoMark: '/assets/logo-mark.png',
  // Future 3D integration point: drop an approved GLB at this path to enable the 3D hero.
  model3d: '/models/metro-one.glb',
};

export const CONTACT = {
  phoneDisplay: '+91 74002 45025',
  phone: '+917400245025',
  whatsapp: '917400245025',
  email: 'sales.metroone@gmail.com',
  website: 'www.metroone.com',
  siteOffice: 'Aarohi Complex, Plot No. 156, Phase-II, Navade, Navi Mumbai – 410208',
};

export const IMAGES = {
  heroElevation: '/assets/hero-elevation.webp',
  elevationDay: '/assets/elevation-day.webp',
  navadeStation: '/assets/navade-station.webp',
  aerialGrowth: '/assets/aerial-growth.webp',
  futureMetro: '/assets/future-metro.webp',
  readyArrival: '/assets/ready-arrival.webp',
  ventilatedLiving: '/assets/ventilated-living.webp',
  balconyXl: '/assets/balcony-xl.webp',
  metroLifestyle: '/assets/metro-lifestyle.webp',
  mapConnectivity: '/assets/map-connectivity.webp',
  mapLine: '/assets/map-line.webp',
  entrance: '/assets/entrance.webp',
  coverFamily: '/assets/cover-family.png',
};

export const HERO = {
  sub: 'Ready-to-move 1 & 2 BHK homes at Aarohi Complex, Navade.',
  trust: [
    'Ready to Move In',
    'G+7 Residential Development',
    '1 & 2 BHK Homes',
    'MahaRERA: P52000015331',
  ],
};

export const MARQUEE_ITEMS = [
  'READY TO MOVE IN',
  'NAVADE · NAVI MUMBAI',
  '1 & 2 BHK HOMES',
  'G+7 DEVELOPMENT',
  'SUBURBAN RAIL CONNECTED',
  'MAHARERA REGISTERED',
];

export const READY_NOW = {
  eyebrow: 'Chapter 01 — The Proposition',
  headlineTop: 'READY IS NOW',
  headlineBottom: 'THE NEW LUXURY.',
  // seamless stitch of brochure pages 6 (facing-page spread) — native 2340×1482, no upscaling
  image: {
    full: '/assets/ch01-ready-spread.webp',
    srcset: '/assets/ch01-ready-spread-1600.webp 1600w, /assets/ch01-ready-spread.webp 2340w',
    width: 2340,
    height: 1482,
    alt: 'Complete approved brochure spread — families moving into the ready Aarohi Complex with the moving truck, entrance, full building and sky',
  },
  story:
    'Buying a home shouldn’t always require imagining what life may look like years from now. At Metro One, you can experience the address — the actual development, the neighbourhood and the surroundings — before making your decision.',
  stages: [
    {
      id: 'see',
      num: '01',
      title: 'SEE IT',
      text: 'Visit the actual development. See the building, neighbourhood and surroundings yourself.',
    },
    {
      id: 'feel',
      num: '02',
      title: 'FEEL IT',
      text: 'Understand the space. Experience the location. Visualise your everyday life.',
    },
    {
      id: 'own',
      num: '03',
      title: 'OWN IT',
      text: 'Move beyond brochures, drawings and construction promises towards a tangible residential address.',
    },
  ],
  closing: 'YOUR NEXT HOME ALREADY HAS AN ADDRESS.',
};

export const EXPLORE = {
  eyebrow: 'Chapter 02 — The Building',
  headline: 'EXPLORE THE BUILDING',
  sub: 'Tap the red markers on the official Aarohi Complex elevation to discover what is already standing.',
  // seamless stitch of brochure page 10 (facing-page spread) — native 4867×3670, no upscaling
  image: {
    full: '/assets/ch02-elevation-spread.webp',
    srcset: '/assets/ch02-elevation-spread-1600.webp 1600w, /assets/ch02-elevation-spread-2400.webp 2400w, /assets/ch02-elevation-spread.webp 4867w',
    width: 4867,
    height: 3670,
    alt: 'Official complete daytime elevation of Aarohi Complex — full G+7 building width with Wings A and B, architectural frames, balconies, windows, entrance, ground-level frontage, landscaping and sky',
  },
  // % coordinates are relative to the stitched image itself (container aspect matches the image exactly)
  hotspots: [
    { id: 'wings', x: 37, y: 14, label: 'Wings A & B', detail: 'A G+7 residential development organised into Wings A and B with efficient residential planning.' },
    { id: 'homes', x: 45, y: 42, label: '1 & 2 BHK Residences', detail: 'Thoughtfully planned 1 & 2 BHK homes — smart configurations in a connected location, at a ready address.' },
    { id: 'balconies', x: 75, y: 55, label: 'Large Balconies', detail: 'Larger-than-life balconies and ventilated homes designed around everyday life.' },
    { id: 'structure', x: 36, y: 33, label: 'RCC Structure', detail: 'RCC earthquake-resistant structure with a dedicated fire-fighting system.' },
    { id: 'water', x: 55, y: 70, label: 'Water & Sustainability', detail: 'Rainwater harvesting with underground and overhead water storage.' },
    { id: 'frontage', x: 62, y: 84, label: 'Ground-Level Frontage', detail: 'An active ground-level frontage that anchors the development to the Navade neighbourhood.' },
  ],
};

export const HOMES = {
  eyebrow: 'Chapter 03 — The Homes',
  headline: 'HOMES DESIGNED AROUND LIFE',
  chapters: [
    {
      id: 'ventilated',
      badge: 'Breeze Sweeps In',
      title: 'VENTILATED HOMES',
      sub: 'DESIGNED AROUND LIFE',
      text: '1 & 2 BHK homes at Navade with living spaces planned for natural light, cross-ventilation and everyday family life.',
      // seamless stitch of brochure page 7 (facing-page spread) — native 1488×887, no upscaling
      image: {
        full: '/assets/ch03-ventilated-spread.webp',
        srcset: '/assets/ch03-ventilated-spread.webp 1488w',
        width: 1488,
        height: 887,
      },
      alt: 'Complete approved brochure spread of a sunlit living and dining space at Aarohi Complex — full family, sheer curtains, balcony and outdoor metro view',
    },
    {
      id: 'balcony',
      badge: 'Balcony in XL Size',
      title: 'LARGER THAN LIFE BALCONY',
      sub: 'DESIGNED AROUND LIFE',
      text: 'Generous balconies that extend the living room outward — space to sit, grow and watch the city move.',
      // seamless stitch of brochure page 8 (facing-page spread) — native 2524×1513, no upscaling
      image: {
        full: '/assets/ch03-balcony-spread.webp',
        srcset: '/assets/ch03-balcony-spread-1600.webp 1600w, /assets/ch03-balcony-spread-2400.webp 2400w, /assets/ch03-balcony-spread.webp 2524w',
        width: 2524,
        height: 1513,
      },
      alt: 'Complete approved brochure spread of the extra-large balcony at Aarohi Complex — full depth, railings, family seating, children, greenery, skyline and metro corridor',
    },
    {
      id: 'lifestyle',
      badge: 'Live. Connect. Thrive.',
      title: 'UPGRADE TO A METRO LIFESTYLE',
      sub: 'IN A FUTURISTIC CITY',
      text: 'A home positioned within Navi Mumbai’s growing urban ecosystem — LIVE. CONNECT. THRIVE.',
      // seamless stitch of brochure page 9 (facing-page spread) — native 1486×887, no upscaling
      image: {
        full: '/assets/ch03-metro-spread.webp',
        srcset: '/assets/ch03-metro-spread.webp 1486w',
        width: 1486,
        height: 887,
      },
      alt: 'Complete approved brochure spread of the Navi Mumbai high street at golden hour — family on the footpath, shops, road, skyline and metro viaduct',
    },
  ],
};

// Carpet areas / pricing intentionally null until verified — see DO-NOT list.
export const PLANS = {
  eyebrow: 'Chapter 04 — The Plans',
  headline: ['FIND THE HOME', 'THAT FITS YOUR PLAN.'],
  note: 'Starting prices are indicative and subject to change. Request the current cost sheet for exact pricing, payment plan and availability.',
  configurations: [
    {
      id: '1bhk',
      label: '1 BHK',
      tag: 'START SMART',
      text: 'A practical first step towards homeownership — for young professionals, couples, small families and investors looking for a Navi Mumbai address with an accessible entry point.',
      carpetArea: '400 – 450 sq.ft. (RERA)',
      price: '₹41 Lakhs onwards',
      availability: 'Contact for details',
    },
    {
      id: '2bhk',
      label: '2 BHK',
      tag: 'MOVE UP',
      text: 'More room for the family. More flexibility for tomorrow — for buyers looking to upgrade their lifestyle while remaining connected to Navi Mumbai’s growing urban ecosystem.',
      carpetArea: '580 – 650 sq.ft. (RERA)',
      price: '₹62 Lakhs onwards',
      availability: 'Contact for details',
    },
  ],
  floorPlans: [
    { id: 'ground', label: 'Ground Floor Plan', image: '/assets/plan-ground.webp' },
    { id: 'first', label: 'First Floor Plan', image: '/assets/plan-first.webp' },
    { id: 'second-fourth', label: '2nd & 4th Floor Plan', image: '/assets/plan-second-fourth.webp' },
    { id: 'third-fifth', label: '3rd & 5th Floor Plan', image: '/assets/plan-third-fifth.webp' },
    { id: 'sixth', label: '6th Floor Plan', image: '/assets/plan-sixth.webp' },
    { id: 'seventh', label: '7th Floor Plan', image: '/assets/plan-seventh.webp' },
  ],
};

export const CONNECTIVITY = {
  eyebrow: 'Chapter 05 — The Location',
  headline: ['ONE ADDRESS.', '360° CONNECTIVITY', 'ECOSYSTEM.'],
  sub: 'NAVADE IS GETTING CLOSER TO EVERYTHING THAT MATTERS.',
  map: '/assets/map-connectivity.webp',
  layers: [
    {
      id: 'rail',
      label: 'Rail',
      status: 'Operational Today',
      short: 'Operational',
      operational: true,
      title: 'RAIL — CONNECTED TODAY',
      text: 'Navade already benefits from suburban railway connectivity, providing residents with an established public-transport option.',
    },
    {
      id: 'road',
      label: 'Road',
      status: 'Existing Road Connectivity',
      short: 'Connected',
      operational: true,
      title: 'ROAD — CONNECTED TO OPPORTUNITY',
      text: 'Access towards Taloja, Kalamboli and Panvel connects Navade with major residential, commercial and transportation nodes.',
    },
    {
      id: 'air',
      label: 'Air',
      status: 'Emerging Infrastructure Ecosystem',
      short: 'Emerging',
      operational: false,
      title: 'AIR — EMERGING ECOSYSTEM',
      text: 'The Navi Mumbai International Airport ecosystem is expected to contribute to the region’s next phase of growth and connectivity.',
    },
    {
      id: 'metro',
      label: 'Metro',
      status: 'Proposed / Subject to Approvals',
      short: 'Proposed',
      operational: false,
      title: 'METRO — EMERGING / PROPOSED',
      text: 'Metro One is positioned within Navi Mumbai’s proposed and emerging future mass-transit ecosystem. Navade Metro Station is part of the proposed corridor and is not presented as an officially operational station.',
    },
  ],
  disclaimer:
    'Map is an artistic representation from the approved project brochure and is not to scale. Proposed and emerging infrastructure is subject to government approvals and timelines. Operational and proposed infrastructure are shown distinctly.',
};

export const SPECS = {
  eyebrow: 'Chapter 06 — The Details',
  headline: ['DETAILS THAT MAKE', 'A HOME COMPLETE'],
  rooms: [
    { id: 'living', label: 'Living Room', image: '/assets/room-living.webp', imageMobile: '/assets/room-living-m.webp', hint: 'Vitrified flooring · Sliding windows · Acrylic matt paint' },
    { id: 'kitchen', label: 'Kitchen', image: '/assets/room-kitchen.webp', imageMobile: '/assets/room-kitchen-m.webp', hint: 'Granite platform · Stainless-steel sink · Tiled dado' },
    { id: 'bedroom', label: 'Bedroom', image: '/assets/room-bedroom.webp', imageMobile: '/assets/room-bedroom-m.webp', hint: 'Vitrified flooring · Concealed copper wiring' },
    { id: 'bathroom', label: 'Bath & WC', image: '/assets/room-bathroom.webp', imageMobile: '/assets/room-bathroom-m.webp', hint: 'Tiled walls · Branded sanitaryware · Concealed plumbing' },
  ],
  items: [
    { id: 'flooring', label: 'Flooring', text: '24” × 24” vitrified flooring in rooms.' },
    { id: 'kitchen', label: 'Kitchen', text: 'Granite kitchen platform with stainless-steel sink and tiled dado.' },
    { id: 'doors', label: 'Doors', text: 'Decorative laminated flush main door with wooden frame and quality internal doors.' },
    { id: 'bath', label: 'Bath & WC', text: 'Tiled walls with branded sanitary ware and concealed plumbing.' },
    { id: 'electrical', label: 'Electrical', text: 'Concealed branded copper wiring with provision for television, telephone and inverter.' },
    { id: 'windows', label: 'Windows', text: 'Powder-coated sliding windows.' },
    { id: 'walls', label: 'Walls & Paint', text: 'Internal acrylic / Sandtex matt paint and external weather-protective finish.' },
    { id: 'water', label: 'Water', text: 'Underground and overhead water tanks with adequate storage capacity.' },
    { id: 'terrace', label: 'Terrace', text: 'Special waterproofing treatment.' },
  ],
};

export const JOURNEY = {
  chapters: ['Arrival', 'Ready', 'Architecture', 'Homes', 'Connected', 'Visit'],
  intro: {
    lines: ['YOUR NEXT HOME', 'IS ALREADY READY.'],
    cue: 'Scroll to Experience',
  },
  approach: { lines: ['LIFE IN A', 'METRO ONE'] },
  ready: {
    steps: ['READY TODAY.', 'READY-TO-MOVE HOMES', 'OC RECEIVED'],
    support: 'No construction waiting. Experience the home that already exists.',
  },
  orbit: {
    words: ['CONNECTED', 'VENTILATED', 'COMPLETE'],
    sub: '1 & 2 BHK ventilated homes at Navade.',
  },
  homes: {
    headline: 'YOUR HOME. YOUR WAY.',
    options: ['Ready Home', 'Customized Semi-Furnished', 'Customized Fully Furnished'],
  },
  breathe: {
    headline: 'SPACE TO BREATHE.',
    support: 'Ventilated homes designed around light, openness and everyday living.',
  },
  connected: {
    headline: 'CONNECTED TO WHAT MOVES YOU.',
    operational: 'Operational today',
    proposed: 'Emerging · proposed',
  },
  final: {
    lines: ['LIFE IN A METRO ONE'],
    sub: 'READY-TO-MOVE 1 & 2 BHK VENTILATED HOMES',
    badge: 'OC RECEIVED',
    note: 'Customized semi-furnished and fully furnished options available.',
    cta: 'Book Your Private Site Visit',
  },
  proposition: 'A once-in-a-lifetime opportunity to own a ready-to-move home with no construction waiting.',
};

export const ENQUIRY = {
  eyebrow: 'Chapter 07 — Your Visit',
  headline: 'SEE IT FOR YOURSELF.',
  sub: 'Book a site visit in under a minute. Walk the actual building before you decide.',
  timelines: ['Immediately', 'Within 3 months', '3–6 months', 'Just exploring'],
  timeSlots: ['Morning (10am–12pm)', 'Afternoon (12–3pm)', 'Evening (3–6pm)'],
  interests: ['1 BHK', '2 BHK', 'Need Guidance'],
  furnishings: ['Ready as-is', 'Semi-furnished', 'Fully furnished', 'Not decided'],
};

export const FOOTER = {
  disclaimer:
    'All the images, pictorials, visuals, elevations, perspectives, illustrations, models, specifications, plans, designs, drawings, dimensions, maps, facilities, amenities, features, and other information/details herein are conceptual, indicative and for representation purpose only and are not to scale, and are subject to the approval of the respective authorities. The Promoters/Developers/Architects reserve the right to add, alter, delete or replace any of these in the interest of the development, without any notice or obligation. This material does not constitute an offer or contract of any nature whatsoever between the Promoters/Developers and the recipient. All transactions in this development shall be subject to and governed by the terms & conditions of the Agreement for Sale to be entered into between the parties. “Metro One” is the project codename; “Aarohi Complex” is the underlying registered project. Proposed or emerging infrastructure (including metro connectivity and the airport ecosystem) is shown as part of the regional growth story and is subject to government approvals.',
};

// ── CMS registry ─────────────────────────────────────────────────────────────
// The admin panel saves published overrides to /api/content. App.js fetches them
// before rendering and merges them IN PLACE, so every static import above keeps
// working while reflecting the published content.
const REGISTRY = {
  BRAND, CONTACT, HERO, MARQUEE_ITEMS, READY_NOW, EXPLORE, HOMES,
  PLANS, CONNECTIVITY, SPECS, JOURNEY, ENQUIRY, FOOTER,
};

function mergeInto(target, patch) {
  if (!patch || typeof patch !== 'object' || Array.isArray(patch) || !target) return patch;
  for (const [k, v] of Object.entries(patch)) {
    if (v && typeof v === 'object' && !Array.isArray(v) && typeof target[k] === 'object' && !Array.isArray(target[k]) && target[k] !== null) {
      mergeInto(target[k], v);
    } else {
      target[k] = v; // scalars and arrays replace wholesale
    }
  }
  return target;
}

export function applyContentOverrides(overrides) {
  if (!overrides || typeof overrides !== 'object') return;
  for (const [k, v] of Object.entries(overrides)) {
    if (REGISTRY[k]) mergeInto(REGISTRY[k], v);
  }
}

// Full current content as a plain JSON snapshot (used by the admin panel to
// initialise the draft on first open).
export function contentSnapshot() {
  return JSON.parse(JSON.stringify(REGISTRY));
}
